import { matchPath } from "react-router-dom";
import { IsMatch } from "./types";

export const isMatch: IsMatch = (pathname, routes) => {
  const pathnames = Array.isArray(pathname) ? pathname : [pathname];
  const routePatterns = Array.isArray(routes) ? routes : [routes];
  return pathnames.some((p) =>
    routePatterns.some((route) => !!matchPath({ path: route, end: false }, p)),
  );
};
